import React from "react";

export const NotFoundPage: React.FC =() => {

    return(
        <>
        </>
    );
}